import React, { PropTypes } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { converDateIntoLocalwithmonth } from "Constants";
import Button from "react-bootstrap-button-loader";



class Usagehistoryuserdatalist extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            resetpassword: false,
            loading: false,
            allowingaccess: false,
            selectedUsers: [],
            showEmailPreviewModal: false,
        };
    }

    openModal = (section) => {
        this.setState({
            isOpen: true,
        });
    };
    closeModal = () => {
        this.setState({ isOpen: false });
    };

    
    render() {
        let { values, index } = this.props;
        // console.log('values',values)
        let tabledate = "";
        tabledate = converDateIntoLocalwithmonth(values.Activedate).format("D MMM YYYY HH:mm A");
        return (
            <tr
                key={index} id={index}
            >
                <td>
                    <div
                        className="row"
                        style={{ display: "flex", paddingLeft: 20, paddingTop: 3 }}
                    >
                        <div className="vcenter">{values.Username}</div>
                    </div>
                </td>
                <td>
                    <div
                        className="row"
                        style={{ display: "flex", paddingLeft: 20, paddingTop: 3 }}
                    >
                        <div className="vcenter">{values.Email}</div>
                    </div>
                </td>
                <td>
                    <div
                        className="row"
                        style={{ display: "flex", paddingLeft: 20, paddingTop: 3 }}
                    >
                        <div className="vcenter">{values.eventname}</div>
                    </div>
                </td>
                <td>
                    <div
                        className="row"
                        style={{ display: "flex", paddingLeft: 19, paddingTop: 3 }}
                    >
                        <div className="vcenter">
                            {tabledate}
                        </div>
                    </div>
                </td>
               
            </tr>
        );
    }
}

export var mapStateToProps = (state) => {
    return {
        session: state.session,
    };
};

export default connect(mapStateToProps, {})(Usagehistoryuserdatalist);
